export default {
  MedicalEquipmentFormFields__APPROVED_DEVICES_SUBTEXT:
    "Please ensure the portable oxygen concentrator is on the list of approved devices",
  MedicalEquipmentFormFields__HEADER: "Medical equipment",
  MedicalEquipmentFormFields__OXYGEN_DEVICES_SUBTEXT:
    "Liquid and compressed oxygen devices are not allowed",
  MedicalEquipmentFormFields__PORTABLE_OXYGEN_CONCENTRATOR:
    "Bringing my own approved portable oxygen concentrator",
};
